"use client";
import { useState } from "react";
import Img from "@/public/images/login.jpg";
import Image from "next/image";
import Link from "next/link";
import Right from "@/public/icon/arrowRight.svg";
import Eye from "@/public/icon/eye.svg";
import { useRouter } from "next/navigation";
import { useSession } from "@/hooks/useSession";
import Cookies from "js-cookie";
import { useSnackbar } from "notistack";

const Register = ({ t }) => {
  const [phoneNumber, setPhoneNumber] = useState("+994");
  const { enqueueSnackbar } = useSnackbar();

  const [showPassword, setShowPassword] = useState(false);
  const router = useRouter();
  const { data: session } = useSession();
  const handleInputChange = (event) => {
    let value = event.target.value;

    if (value.startsWith("+994")) {
      setPhoneNumber(value);
    } else {
      setPhoneNumber("+994" + value.replace(/^(\+994)/, ""));
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    const phone = phoneNumber;
    const password = e.currentTarget.password.value;
    const full_name = e.currentTarget.full_name.value;

    register(phone, password, full_name);
  };
  const register = async (phone, password, full_name) => {
    try {
      const res = await fetch("https://api.iyde.az/api/auth/register", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          phone,
          password,
          full_name,
        }),
      });

      const resData = await res.json();

      if (!res.ok || resData.success === false) {
        const errorMessage = resData?.title
          ? t[resData.title] || resData.message
          : resData?.message || t["errors.bad_credentials"];

        enqueueSnackbar(errorMessage, { variant: "error" });

        return;
      }

      const token = resData.token;

      const response = await fetch("/api/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ token }),
      });

      const loginData = await response.json();

      if (!response.ok || loginData.success === false) {
        enqueueSnackbar(loginData?.message || t["errors.bad_credentials"], {
          variant: "error",
        });

        return;
      }
      router.push(`/auth/register-otp?phone=${phone}`);
    } catch (error) {
      console.error("Register error:", error.message);
    }
  };

  return (
    <div className="container">
      <div className="row">
        <div className="xl-6 lg-6 md-6 sm-12">
          <div className="loginLeft">
            <div className="loginTitle">
              <Link href="/auth/login">{t["buttons_login"]}</Link>
              <Link href="/auth/register" className="active">
                {t["title.register"]}
              </Link>
            </div>
            <h1>{t["welcome.title"]}</h1>
            <p>{t["register.title"]}</p>
            <form action="" onSubmit={handleSubmit}>
              <div className="inputChild">
                <input
                  type="text"
                  required
                  placeholder={t["forms.first_name"]}
                  name="full_name"
                />
              </div>
              <div className="inputChild">
                <input
                  type="text"
                  required
                  placeholder={t["forms.numbers"]}
                  value={phoneNumber}
                  onChange={handleInputChange}
                />
              </div>
              <div className="inputChild">
                <input
                  type={showPassword ? "text" : "password"}
                  required
                  placeholder={t["forms.password"]}
                  id="password"
                  name="password"
                />
                {showPassword ? (
                  <div
                    className="eye "
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    <Eye />
                  </div>
                ) : (
                  <div
                    className="eye active"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    <Eye />
                  </div>
                )}
              </div>

              <button type="submit" className="blackButton">
                {t["title.register"]}
                <Right />
              </button>
            </form>
          </div>
        </div>
        <div className="xl-6 lg-6 md-6 sm-12">
          <div className="img">
            <Image src={Img} alt="login" width={300} height={300} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
